"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryTransactions = void 0;

var _common = require("./../common");

var _utils = require("./../common/utils");

var _service = require("./../service");

class BasisTheoryTransactions extends _service.BasisTheoryService {
  constructor(options) {
    const _options = { ...options
    }; // eslint-disable-next-line unicorn/prefer-spread

    _options.transformRequest = [].concat(_utils.transformProxyRequestSnakeCase, options.transformRequest || []); // eslint-disable-next-line unicorn/prefer-spread

    _options.transformResponse = [].concat(_utils.transformProxyResponseCamelCase, options.transformResponse || []);
    super(_options);
  }

  create(options = {}) {
    return this.client.post('/', undefined, (0, _common.createRequestConfig)(options)).then(_utils.dataExtractor);
  }

  commit(id, options = {}) {
    const url = `/${id}/commit`;
    return this.client.post(url, undefined, (0, _common.createRequestConfig)(options)).then(_utils.dataExtractor);
  }

  rollback(id, options = {}) {
    const url = `/${id}/rollback`;
    return this.client.post(url, undefined, (0, _common.createRequestConfig)(options)).then(_utils.dataExtractor);
  }

}

exports.BasisTheoryTransactions = BasisTheoryTransactions;